module.exports = __webpack_public_path__ + "static/img/sx.59269969.png";